// extracted by mini-css-extract-plugin
export default {"adminLayout":"AdminLayout_adminLayout__Ecdv-","mainContent":"AdminLayout_mainContent__w1FuB","pageContent":"AdminLayout_pageContent__Zapkj"};